<template>
  <div ref="el">
    <div v-if="nodeData">
      <div class="configurable-node-header">
        <contenteditable
          v-if="source === 'action_plan'"
          tag="span"
          class="configurable-node-header__title configurable-node-header__title--editable d-block"
          :contenteditable="true"
          v-model="title"
          :noNL="true"
          @input="updateTitle"
        />
        <span
          v-else
          class="configurable-node-header__title d-block"
        >
          {{ resolveNodeName(nodeData) }}
        </span>
        <span
          v-if="nodeData.data.cmd !== 'custom'"
          class="config-icon"
          @click="openConfigModal"
        >
          <feather-icon icon="SettingsIcon" size="16" class="" />
        </span>
      </div>
      <div class="node-chart" v-if="chartType" :key="`chart-${chartKey}`">
        <e-charts :options="chartOption" autoresize class="node-chart__canvas" />
      </div>
      <div class="action-plan-plan" v-if="source === 'action_plan'">
        <b-form-checkbox
          class="check-box-node"
          v-model="data.required"
          value="1"
          unchecked-value="0"
          switch
          size="sm"
          @change="onChange"
          :key="`${data.key}`"
        >
          Requerido
        </b-form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";
import { EventBus } from "@/libs/event-bus";
import contenteditable from "@/components/Contenteditable";
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/graph";
import "echarts/lib/component/tooltip";

export default {
  components: { ECharts, contenteditable },
  props: {
    source: {
      type: String,
      default: "commands",
    },
  },
  mixins: [nodeMixin],
  data() {
    return {
      data: {
        key: 1,
      },
      title: "",
      chartKey: 0,
    };
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();
    this.title = this.resolveNodeTitle(this.nodeData);

    EventBus.on("node:data-updated", this.onNodeDataUpdated);

    if (this.source === "action_plan") {
      this.$nextTick(() => {
        this.data.required = this.nodeData.data.required;
        this.data.key++;
      });
    }
  },
  beforeDestroy() {
    EventBus.off("node:data-updated", this.onNodeDataUpdated);
  },
  computed: {
    chartType() {
      const t = this.nodeData && this.nodeData.data && this.nodeData.data.storage;
      return t && t.chart_type;
    },
    chartOption() {
      return this.buildChartOption(this.chartType);
    },
  },
  methods: {
    onNodeDataUpdated(id) {
      if (id !== this.nodeId) return;
      this.nodeData = this.$df.getNodeFromId(this.nodeId);
      this.title = this.resolveNodeTitle(this.nodeData);
      this.chartKey++;
    },
    onChange(val) {
      this.data.required = val;
      this.updateNodeData({ required: val });
    },
    openConfigModal() {
      EventBus.emit("node:open-modal", this.nodeId);
    },
    updateTitle(value) {
      this.title = value;
      const currentNode = this.$df.getNodeFromId(this.nodeId);
      this.updateNodeData({
        config: {
          ...(currentNode.data.config || {}),
          title: value,
        },
      });
    },
    resolveNodeTitle(nodeData) {
      const title = nodeData?.data?.config?.title;
      return typeof title === "string" && title.trim() !== ""
        ? title
        : this.resolveNodeName(nodeData);
    },
    resolveNodeName(nodeData) {
      return nodeData.data.cmd !== "custom"
        ? this.$t(`commands.list.${nodeData.name}.name`)
        : nodeData.name;
    },
    buildChartOption(type) {
      const labels = ["A", "B", "C", "D"];
      const values = [12, 28, 19, 35];
      if (type === "bar") {
        return {
          tooltip: { trigger: "axis" },
          grid: { left: 4, right: 8, top: 8, bottom: 4, containLabel: true },
          xAxis: { type: "category", data: labels },
          yAxis: { type: "value" },
          series: [{ type: "bar", data: values }],
        };
      }
      if (type === "line") {
        return {
          tooltip: { trigger: "axis" },
          grid: { left: 4, right: 8, top: 8, bottom: 4, containLabel: true },
          xAxis: { type: "category", data: labels },
          yAxis: { type: "value" },
          series: [{ type: "line", data: values, smooth: true }],
        };
      }
      if (type === "pie") {
        return {
          tooltip: { trigger: "item" },
          series: [
            {
              type: "pie",
              radius: ["35%", "70%"],
              label: { show: false },
              data: labels.map((n, i) => ({ name: n, value: values[i] })),
            },
          ],
        };
      }
      if (type === "graph") {
        return {
          tooltip: {},
          series: [
            {
              type: "graph",
              layout: "force",
              roam: true,
              label: { show: true, fontSize: 9 },
              force: { repulsion: 60, edgeLength: 40 },
              data: [
                { name: "Placa", symbolSize: 28 },
                { name: "Cámara 1", symbolSize: 18 },
                { name: "Cámara 2", symbolSize: 18 },
                { name: "Vehículo", symbolSize: 18 },
              ],
              links: [
                { source: "Placa", target: "Cámara 1" },
                { source: "Placa", target: "Cámara 2" },
                { source: "Vehículo", target: "Placa" },
              ],
            },
          ],
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss">
.node-chart {
  margin-top: 6px;
  width: 180px;
  height: 110px;
  pointer-events: none;

  &__canvas {
    width: 100%;
    height: 100%;
  }
}
</style>
